export const SIGNIN_PREFILL_EMAIL_KEY = "upsider_signin_prefill_email";

export function takeSigninPrefillEmail(): string {
  try {
    const value = sessionStorage.getItem(SIGNIN_PREFILL_EMAIL_KEY) ?? "";
    sessionStorage.removeItem(SIGNIN_PREFILL_EMAIL_KEY);
    return value.trim();
  } catch {
    return "";
  }
}
